export default __webpack_public_path__ + "static/media/ic_blowing_sand.deb9d47d.svg";